var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBenefitAdvanced(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(0px)",
      clipPath: "url(#bgblur_0_9400_479_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-figma-bg-blur-radius": 0,
    cx: 24.5,
    cy: 24.5,
    r: 24.5,
    fill: "url(#paint0_linear_9400_479)",
    fillOpacity: 0.24
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(0px)",
      clipPath: "url(#bgblur_1_9400_479_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    "data-figma-bg-blur-radius": 0,
    cx: 24.5,
    cy: 24.5,
    r: 18.5,
    fill: "url(#paint1_linear_9400_479)",
    fillOpacity: 0.24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 21.5H24.5",
    stroke: "#000102",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 24.5L17.5 21.5L20.5 18.5",
    stroke: "#000102",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 27.5H22.5",
    stroke: "#000102",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 24.5L29.5 27.5L26.5 30.5",
    stroke: "#000102",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 30L23.5 35.5L13.5 30V19L23.5 13.5L33.5 19V30Z",
    stroke: "#000102",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_9400_479_clip_path"
  }, /*#__PURE__*/React.createElement("circle", {
    transform: "translate(0 0)",
    cx: 24.5,
    cy: 24.5,
    r: 24.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_9400_479_clip_path"
  }, /*#__PURE__*/React.createElement("circle", {
    transform: "translate(0 0)",
    cx: 24.5,
    cy: 24.5,
    r: 18.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9400_479",
    x1: 25.213,
    y1: 8.91922,
    x2: 23.8224,
    y2: 44.1105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5445FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9400_479",
    x1: 25.0384,
    y1: 12.7349,
    x2: 23.9883,
    y2: 39.3079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5445FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitAdvanced);
export default __webpack_public_path__ + "res/media/benefit-advanced.234dbb399b2797845e80a75561ea36fc.svg";
export { ForwardRef as ReactComponent };